import { json3n35pf5np6si4 as json } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__plus_impl_yu9v8f2gb5hwgakp0dd as Duration__plus_impl_yu9v8f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Monotonic_instance6v32gqtywf7e as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs1dlqois04h852 as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function subObj($this, _this__u8e3s4, key) {
  var tmp = _this__u8e3s4[key];
  var tmp0_elvis_lhs = (!(tmp == null) ? !(tmp == null) : false) ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    var obj = json([]);
    _this__u8e3s4[key] = obj;
    tmp_0 = obj;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function jsonForEach($this, obj, action) {
  return function () {
    for (var key in obj) {
      action(key, obj[key]);
    }
    return void 3;
  }();
}
function DynamicCss$customStyleSheetElement$delegate$lambda() {
  var tmp = document.createElement('style');
  var sheet = tmp instanceof HTMLStyleElement ? tmp : THROW_CCE();
  sheet.title = 'generated-css';
  ensureNotNull(document.head).appendChild(sheet);
  return sheet;
}
function DynamicCss$_get_customStyleSheetElement_$ref_s5nun7() {
  return (p0) => p0.adp();
}
function DynamicCss$_get_customStyleSheet_$ref_cvbo9x() {
  return (p0) => p0.bdp();
}
var DynamicCssClass;
function DynamicCss() {
  if (DynamicCssClass === VOID) {
    class $ {
      constructor(basePath) {
        this.qb1_1 = basePath;
        var tmp = this;
        tmp.rb1_1 = lazy(DynamicCss$customStyleSheetElement$delegate$lambda);
        var tmp_0 = this;
        tmp_0.sb1_1 = lazy(() => {
          this.adp();
          // Inline function 'kotlin.let' call
          var tmp0 = document.styleSheets;
          var tmp$ret$2;
          $l$block: {
            var inductionVariable = 0;
            var last = tmp0.length;
            if (inductionVariable < last)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'org.w3c.dom.css.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = tmp0[i];
                var copy = ensureNotNull(tmp$ret$1);
                if (copy.title === this.adp().title) {
                  tmp$ret$2 = copy instanceof CSSStyleSheet ? copy : THROW_CCE();
                  break $l$block;
                }
              }
               while (inductionVariable < last);
            throw IllegalStateException().kd();
          }
          return tmp$ret$2;
        });
        this.tb1_1 = HashSet().ha();
        this.ub1_1 = json([]);
        var tmp_1 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        tmp_1.vb1_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
        this.wb1_1 = 0;
      }
      adp() {
        var tmp0 = this.rb1_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('customStyleSheetElement', 1, tmp, DynamicCss$_get_customStyleSheetElement_$ref_s5nun7(), null);
        return tmp0.f2();
      }
      bdp() {
        var tmp0 = this.sb1_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('customStyleSheet', 1, tmp, DynamicCss$_get_customStyleSheet_$ref_cvbo9x(), null);
        return tmp0.f2();
      }
      ab3(font) {
        if (!this.tb1_1.v(font.jax_1))
          return font.jax_1;
        if (!(font.kax_1 == null)) {
          var tmp = ensureNotNull(document.head);
          var tmp_0 = document.createElement('link');
          // Inline function 'kotlin.apply' call
          var this_0 = tmp_0 instanceof HTMLLinkElement ? tmp_0 : THROW_CCE();
          this_0.rel = 'stylesheet';
          this_0.type = 'text/css';
          this_0.href = font.kax_1;
          tmp.appendChild(this_0);
        }
        if (!(font.max_1 == null)) {
          // Inline function 'kotlin.collections.forEach' call
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = font.max_1.hay_1.d2().m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            this.zb1("@font-face {font-family: '" + font.jax_1 + "';font-style: normal;font-weight: " + element.e2() + ";src:url('" + (this.qb1_1 + element.f2()) + "');}");
          }
          // Inline function 'kotlin.collections.forEach' call
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = font.max_1.iay_1.d2().m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            this.zb1("@font-face {font-family: '" + font.jax_1 + "';font-style: italic;font-weight: " + element_0.e2() + ";src:url('" + (this.qb1_1 + element_0.f2()) + "');}");
          }
        }
        return font.jax_1;
      }
      bb2(rule, index) {
        try {
          return this.bdp().insertRule(rule, index);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            throw Exception().vd('Failed to add rule ' + rule, e);
          } else {
            throw $p;
          }
        }
      }
      zb1(rule, index, $super) {
        index = index === VOID ? 0 : index;
        return $super === VOID ? this.bb2(rule, index) : $super.bb2.call(this, rule, index);
      }
      xb1(selector, key, value, media) {
        subObj(this, subObj(this, this.ub1_1, media), selector)[key] = value;
      }
      oc() {
        // Inline function 'kotlin.time.measureTime' call
        // Inline function 'kotlin.time.measureTime' call
        var mark = Monotonic_instance.hj();
        var tmp = this.ub1_1;
        jsonForEach(this, tmp, (media, it) => {
          var str = {_v: '@media ' + media + ' {'};
          var tmp = (!(it == null) ? !(it == null) : false) ? it : THROW_CCE();
          jsonForEach(this, tmp, (selector, it) => {
            str._v = str._v + selector;
            str._v = str._v + '{';
            var tmp = (!(it == null) ? !(it == null) : false) ? it : THROW_CCE();
            jsonForEach(this, tmp, (key, value) => {
              str._v = str._v + key;
              str._v = str._v + ':';
              str._v = str._v + toString(value);
              str._v = str._v + ';';
              return Unit_instance;
            });
            str._v = str._v + '}';
            this.wb1_1 = this.wb1_1 + 1 | 0;
            return Unit_instance;
          });
          str._v = str._v + '}';
          this.bb2(str._v, 0);
          return Unit_instance;
        });
        this.ub1_1 = json([]);
        var tmp$ret$2 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
        // Inline function 'kotlin.also' call
        var this_0 = new (Duration())(tmp$ret$2);
        var it = this_0.nj_1;
        this.vb1_1 = Duration__plus_impl_yu9v8f(this.vb1_1, it);
        this_0.nj_1;
      }
    }
    initMetadataForClass($, 'DynamicCss');
    DynamicCssClass = $;
  }
  return DynamicCssClass;
}
//region block: exports
export {
  DynamicCss as DynamicCssr3610hzbsxx2,
};
//endregion

//# sourceMappingURL=DynamicCss.js.mjs.map
